import { render, staticRenderFns } from "./DialogErrorDesempregado.vue?vue&type=template&id=bdda5ef6&scoped=true"
import script from "./DialogErrorDesempregado.vue?vue&type=script&lang=ts"
export * from "./DialogErrorDesempregado.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdda5ef6",
  null
  
)

export default component.exports